import React from 'react';
import './ProfileConfigurationButton.css';

type ProfileConfigurationButtonProps = {
  onClick: () => void;
};

export const ProfileConfigurationButton: React.FC<
  ProfileConfigurationButtonProps
> = ({ onClick }) => {
  return (
    <button
      type='button'
      onClick={onClick}
      className='topbar__btn topbar__btn-primary'
    >
      <span className='channel-config-trigger__icon' aria-hidden='true'>
        <svg
          width='16'
          height='17'
          viewBox='0 0 16 17'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M6.82324 0.294116C7.55853 -0.0980385 8.44147 -0.0980385 9.17676 0.294116L14.6768 3.22771C15.4913 3.66223 16 4.51058 16 5.43376V11.0334C16 11.9566 15.4913 12.8049 14.6768 13.2394L9.17676 16.173C8.44147 16.5652 7.55853 16.5652 6.82324 16.173L1.32324 13.2394C0.508729 12.8049 0 11.9566 0 11.0334V5.43376C9.74379e-06 4.51058 0.508725 3.66223 1.32324 3.22771L6.82324 0.294116ZM8.70605 1.17693C8.26488 0.941639 7.73512 0.941639 7.29395 1.17693L1.79395 4.11052C1.30535 4.37126 1.00001 4.87993 1 5.43376V11.0334C1 11.5873 1.30515 12.0969 1.79395 12.3576L7.29395 15.2902C7.73512 15.5255 8.26488 15.5255 8.70605 15.2902L14.2061 12.3576C14.6948 12.0969 15 11.5873 15 11.0334V5.43376C15 4.87993 14.6946 4.37126 14.2061 4.11052L8.70605 1.17693ZM8 5.23357C9.65685 5.23357 11 6.57673 11 8.23357C11 9.89042 9.65685 11.2336 8 11.2336C6.34315 11.2336 5 9.89042 5 8.23357C5.00001 6.57673 6.34315 5.23357 8 5.23357ZM8 6.23357C6.89544 6.23357 6.00001 7.12901 6 8.23357C6 9.33814 6.89543 10.2336 8 10.2336C9.10457 10.2336 10 9.33814 10 8.23357C9.99999 7.12901 9.10456 6.23357 8 6.23357Z'
            fill='white'
          />
        </svg>
      </span>

      <span className='channel-config-trigger__text'>
        Profile configuration
      </span>
    </button>
  );
};
